// // Vaanmathi
// import React, { Fragment } from "react";
// import { Link } from "react-router-dom";
// import logo from "../../../assets/idlbay.png";

// const Footer = () => {
//   return (
//     <Fragment>
//       <footer
//         className="footer mt-auto py-3 text-center"
//         style={{
//           fontFamily: "Fira Code",
//           background: "#fff",
//           borderTop: "1px solid #eee",
//           fontSize: "1rem",
//         }}
//       >
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-12 col-md-6 text-start">
//               <span className="text-muted">
//                 &copy; 2025 Payroll Product. All Rights Reserved.
//               </span>
//             </div>
//             <div className="col-12 col-md-6 text-end">
//               <span className="text-muted">
//                 Powered By
//                 <Link to="#" className="fw-semibold ms-2">
//                   <img
//                     src={logo}
//                     alt="IDLBAy"
//                     style={{ height: "28px", verticalAlign: "middle" }}
//                   />
//                 </Link>
//               </span>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </Fragment>
//   );
// };

// export default Footer;



// Updated By Maran - 04.10.2025
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/idlbay.png";

const Footer = () => {
  return (
    <Fragment>
      <footer
        className="footer mt-auto py-3"
        style={{
          fontFamily: "Fira Code, monospace",
          background: "#fff",
          borderTop: "1px solid #e9ecef",
          fontSize: "0.875rem",
          width: "100%",
          flexShrink: 0,
        }}
      >
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between">
            {/* Copyright Text - Left Side */}
            <div className="col-12 col-md-6 mb-2 mb-md-0">
              <div className="d-flex justify-content-center justify-content-md-start">
                <span 
                  className="text-muted"
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "400"
                  }}
                >
                  &copy; 2025 Payroll Product. All Rights Reserved.
                </span>
              </div>
            </div>
            
            {/* Powered By - Right Side */}
            <div className="col-12 col-md-6">
              <div className="d-flex justify-content-center justify-content-md-end align-items-center">
                <span 
                  className="text-muted me-2"
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "400"
                  }}
                >
                  Powered By
                </span>
                <Link 
                  to="https://idlbay.com" 
                  className="fw-semibold"
                  style={{
                    textDecoration: "none",
                    transition: "opacity 0.2s ease"
                  }}
                  onMouseEnter={(e) => e.target.style.opacity = "0.7"}
                  onMouseLeave={(e) => e.target.style.opacity = "1"}
                >
                  <img
                    src={logo}
                    alt="IDLBAy"
                    style={{ 
                      height: "24px", 
                      verticalAlign: "middle",
                      transition: "transform 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <style>{`
          @media (max-width: 768px) {
            .footer {
              padding-top: 0.75rem !important;
              padding-bottom: 0.75rem !important;
            }
            .footer .container-fluid {
              padding-left: 1rem;
              padding-right: 1rem;
            }
          }
          
          @media (max-width: 576px) {
            .footer {
              font-size: 0.75rem !important;
            }
            .footer img {
              height: 20px !important;
            }
          }
          
          @media (max-width: 360px) {
            .footer {
              padding-top: 0.5rem !important;
              padding-bottom: 0.5rem !important;
            }
            .footer .row {
              flex-direction: column;
              gap: 0.5rem;
            }
            .footer .col-12 {
              text-align: center !important;
            }
          }
        `}</style>
      </footer>
    </Fragment>
  );
};

export default Footer;